/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Mobile_LabelInputs */

const en_fc_cmp_mobile_label = /** @type {(inputs: Fc_Cmp_Mobile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile app`)
};

/**
* | output |
* | --- |
* | "Mobile app" |
*
* @param {Fc_Cmp_Mobile_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_mobile_label = /** @type {((inputs?: Fc_Cmp_Mobile_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Mobile_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_mobile_label(inputs)
});
export { fc_cmp_mobile_label as "fc.cmp.mobile.label" }